const HomePageActionTypes = {
  TOGGLE_SIDENAV_HIDDEN: 'TOGGLE_SIDENAV_HIDDEN',
};

export default HomePageActionTypes;
